/*
 * @Author: dengyongliang
 * @Date: 2021-05-27 16:57:09
 * @LastEditTime: 2021-07-01 09:20:18
 * @LastEditors: dengyongliang
 * @Description: 空
 */
'use strict'
import axios from '@/global/axios.js'
import * as action from '@/actions/brand'
// 提交品牌监控数据
export const BRAND_SAFE_MONITOR_APPLY = (brandNameCn, brandNameEn, brandNamePy, brandNameOther, brandIndustry, domainSuffix, holdDomains, holdTms, callPhone, callCode) => {
  return axios({
    url: action.BRAND_SAFE_MONITOR_APPLY,
    method: 'POST',
    data: { brandNameCn, brandNameEn, brandNamePy, brandNameOther, brandIndustry, domainSuffix, holdDomains, holdTms, callPhone, callCode }
  })
}
// 提交品牌监控联系人信息
export const BRAND_SAFE_MONITOR_FILL = (id, contactName, contactCompany, contactEmail) => {
  return axios({
    url: action.BRAND_SAFE_MONITOR_FILL,
    method: 'POST',
    data: { id, contactName, contactCompany, contactEmail }
  })
}
// 核心品牌域名列表
export const BRAND_SAFE_MONITOR_CORE_DOMAIN_LIST = (safeCode, pageNum, pageSize) => {
  return axios({
    url: action.BRAND_SAFE_MONITOR_CORE_DOMAIN_LIST,
    method: 'POST',
    data: { safeCode, pageNum, pageSize }
  })
}
// 近似商标清单
export const BRAND_SAFE_MONITOR_SIMILAR_TM_LIST = (safeCode, orderProperty, orderType, pageNum, pageSize) => {
  return axios({
    url: action.BRAND_SAFE_MONITOR_SIMILAR_TM_LIST,
    method: 'POST',
    data: { safeCode, orderProperty, orderType, pageNum, pageSize }
  })
}
// 异常域名清单
export const BRAND_SAFE_MONITOR_EXCEPT_DOMAIN_LIST = (safeCode, pageNum, pageSize) => {
  return axios({
    url: action.BRAND_SAFE_MONITOR_EXCEPT_DOMAIN_LIST,
    method: 'POST',
    data: { safeCode, pageNum, pageSize }
  })
}
// 域名检测结果
export const BRAND_SAFE_MONITOR_MONITOR_DOMAIN_LIST = (safeCode, pageNum, pageSize) => {
  return axios({
    url: action.BRAND_SAFE_MONITOR_MONITOR_DOMAIN_LIST,
    method: 'POST',
    data: { safeCode, pageNum, pageSize }
  })
}
// 查询品牌安全监控报告
export const BRAND_SAFE_MONITOR_INFO = safeCode => {
  return axios({
    url: action.BRAND_SAFE_MONITOR_INFO,
    method: 'POST',
    data: { safeCode }
  })
}



// WEBPACK FOOTER //
// ./src/api/brand.js